export default "__VITE_ASSET__CyXBoWBM__"